import { observer } from "mobx-react-lite";
import React from "react";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import type { ViewComponent } from "@frui.ts/views/dist";
import { preventDefault } from "@frui.ts/views/dist";
import type ChangeLicensePlateViewModel from "viewModels/callCenter/search/charges/changeLicensePlateViewModel";
import CountrySelect from "views/common/countrySelect";
import LicensePlateInput from "controls/licensePlateInput";
import FormGroup from "controls/formGroup";
import FormLabel from "controls/formLabel";
import AdvancedInput, { Transformation } from "@edaz/edazkit/controls/AdvancedInput";
import { Input } from "@frui.ts/bootstrap";
import { formatDateTime } from "utils/localizations";

const ChangeLicensePlateFormView: ViewComponent<ChangeLicensePlateViewModel> = observer(({ vm }) => {
  if (!vm.item) {
    return null;
  }

  return (
    <Form onSubmit={preventDefault(vm.onSave)}>
      <div className="bg-light mb-4 p-4 rounded">
        <Form.Row>
          <Form.Group as={Col} className="mb-4">
            <Form.Label>{vm.translate("oldCountryId")}</Form.Label>
            <div>{vm.formatCountry(vm.chargeResponseVehicle.countryId)}</div>
          </Form.Group>
          <Form.Group as={Col} className="mb-4">
            <Form.Label>{vm.translate("oldLicensePlate")}</Form.Label>
            <div>{vm.chargeResponseVehicle.licensePlate}</div>
          </Form.Group>
        </Form.Row>
        <Form.Row>
          <Form.Group as={Col} className="mb-4">
            <Form.Label>{vm.translate("validSince")}</Form.Label>
            <div>{formatDateTime(vm.chargeResponse.validSince)}</div>
          </Form.Group>
          <Form.Group as={Col} className="mb-4">
            <Form.Label>{vm.translate("validUntil")}</Form.Label>
            <div>{formatDateTime(vm.chargeResponse.validUntil)}</div>
          </Form.Group>
        </Form.Row>
        <Form.Row>
          <Form.Group as={Col} className="mb-4">
            <Form.Label>{vm.translate("orderIdent")}</Form.Label>
            <div>{vm.chargeResponse.orderIdent}</div>
          </Form.Group>
        </Form.Row>
      </div>
      <Form.Row>
        <FormGroup as={Col} target={vm.item} property="countryId">
          <FormLabel>{vm.translateAttribute("countryId")}</FormLabel>
          <CountrySelect vm={vm.countrySelectViewModel} />
        </FormGroup>
        <FormGroup as={Col} target={vm.item} property="licensePlate">
          <FormLabel>{vm.translateAttribute("licensePlate")}</FormLabel>
          <LicensePlateInput />
        </FormGroup>
      </Form.Row>
      <Form.Row style={{ paddingBottom: "1.5rem" }}>
        <FormGroup as={Col} md={6} target={vm.item} property="officialRecordId">
          <FormLabel required={true}>{vm.translateAttribute("officialRecordId")}</FormLabel>
          <AdvancedInput transformation={Transformation.UpperCased} />
        </FormGroup>
        <FormGroup as={Col} md={6} target={vm.item} property="emailAddress">
          <FormLabel>{vm.translateAttribute("emailAddress")}</FormLabel>
          <Input disabled={vm.isChangeEmailDisabled} />
        </FormGroup>
      </Form.Row>
    </Form>
  );
});

export default ChangeLicensePlateFormView;
